<template>
    <div class="teamInfo">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <el-carousel indicator-position="none" arrow="always" class="carouselCard">
                <el-carousel-item v-for="(item,index) in cardList" :key="index" style="height:100%">
                    <el-row :gutter="20">
                        <el-col :span="4" v-for="(v, i) in item" :key="i">
                            <div class="cardListImg" @click="rowClick(v)">
                                <img :src="v.imgUrl" :alt="v.imgAlt">
                                <h3>{{ v.title }}</h3>
                            </div>
                        </el-col>
                    </el-row>
                </el-carousel-item>
            </el-carousel>
            <img :src="cardList[0].imgUrl" style="width:100%; opacity: 0;" alt="" />
        </div>
        <!--图片弹窗-->
        <img-dialog ref="img"/>
    </div>
</template>.
<script>
import imgDialog from '@/components/common/components/imgDialog'
export default {
    components: {
        imgDialog
    },
    props: {
        val: {}
    },
    data(){
        return{
            cardList:[],
            screenWidth: document.body.clientWidth,
        }
    },
    methods:{
        rowClick(row){
            if(row.linkUrl){
                window.open(row.linkUrl, '_self');
            }else{
                this.$refs.img.open(row);
            }
        },
        newDataMethods(){
            let newDataList = []
            let current = 0
            if(this.val.attaches && this.val.attaches.length>0){
                for(let i = 0; i <= this.val.attaches.length - 1; i++){
                    if(i%5 !== 0 || i === 0 ){
                        if(!newDataList[current]){
                        newDataList.push([this.val.attaches[i]])
                        }else{
                        newDataList[current].push(this.val.attaches[i])
                        }
                    }else{
                        current++
                        newDataList.push([this.val.attaches[i]])
                    }
                }
            }
            this.cardList = [...newDataList]
        },
        smallnewDataMethods(){
            let newDataList = []
            let current = 0
            if(this.val.attaches && this.val.attaches.length>0){
                for(let i = 0; i <= this.val.attaches.length - 1; i++){
                    if(i%2 !== 0 || i === 0 ){
                        if(!newDataList[current]){
                            newDataList.push([this.val.attaches[i]])
                        }else{
                        newDataList[current].push(this.val.attaches[i])
                        }
                    }else{
                        current++
                        newDataList.push([this.val.attaches[i]])
                    }
                }
            }
            this.cardList = [...newDataList]
        },
        screenMethods(){
            if(this.screenWidth < 768){
                this.smallnewDataMethods();
            }else{
                this.newDataMethods()
            }
        }
    },
    created() {
      this.screenMethods()
    },
    mounted(){
      const _this = this;
        window.onresize = () => (() => {
            window.screenWidth = document.body.clientWidth;
            _this.screenWidth = window.screenWidth;
        })();
    },
    watch: {
      screenWidth(val) {
        this.screenMethods()
      }
    }
}
</script>
<style lang="less" scoped>
.teamInfo{
    .carouselCard {
        .el-col-4{
            width: 50%;
        }
        /deep/.el-carousel__container{
            height:200px;
        }
        .cardListImg{
            border-radius: 4px;
            width: 100%;
            position: relative;
            overflow: hidden;
            border-radius: 4px;
            box-sizing: border-box;
            cursor: pointer;
            height: 200px;
            img{
                width: 100%;
                height: 100%;
                display: block;
            }
            h3{
                background: rgba(0, 0, 0, .5);
                margin: 0 ;
                line-height: 30px;
                font-size: 16px;
                font-weight: normal;
                color: #fff;
                position: absolute;
                bottom: 0;
                left:0px;
                display: inline-block;
                width: 100%;
            }
        }
    }
    @media (min-width: 768px) {
        .carouselCard {
            .el-col-4{
                width: 20%;
            }
        }
    }
    @media (min-width: 768px) and (max-width: 1024px) {
        .carouselCard {
            .cardListImg,/deep/.el-carousel__container{
                height: 200px;
            }
        }
    }
    @media (min-width: 1024px) and (max-width: 1200px) {
        .carouselCard {
            .cardListImg,/deep/.el-carousel__container{
                height: 205px;
            }
        }
    }
    @media only screen and (min-width: 1200px){
        .carouselCard {
            .cardListImg,/deep/.el-carousel__container{
                height: 257px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch7.vue